import { render, staticRenderFns } from "./DestinationDetails.vue?vue&type=template&id=2d6470e4"
import script from "./DestinationDetails.vue?vue&type=script&lang=js"
export * from "./DestinationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports